import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default class Gallery {
    constructor() {
        if($('.js-gallery').length) {
            const $gallerySlider = $('.js-gallery');

            $gallerySlider.each(function() {
                const $slider = $(this)[0];

                const gallerySlider = new Swiper($slider, {
                    autoplay: {
                        delay: 5000
                    },
                    loop: true,
                    modules: [
                        Autoplay,
                        Pagination
                    ],
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination'
                    },
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    breakpoints: {
                        768: {
                            slidesPerGroup: 2,
                            slidesPerView: 2
                        }
                    }
                });
            });
        };
    };
};
